@if (reportType !== 'SURGERY_STATS') {
<stx-checkbox-group-filter
  [formGroupReference]="formGroupReference"
  filterName="treatmentStatus"
  [dictionaryOptions]="dictionaryOptions"
  (filterChange)="onFilterChange($event)"
></stx-checkbox-group-filter>
} @else {
<stx-checkbox-group-filter
  [formGroupReference]="formGroupReference"
  filterName="treatmentStatus"
  [dictionaryOptions]="inProgressToComboOptions"
  (filterChange)="onFilterChange($event)"
></stx-checkbox-group-filter>
<stx-checkbox-tree-filter
  [dictionariesTree]="reimbursableOptions"
  [formGroupReference]="formGroupReference.get(REIMBURSABLE_VALUE)"
  [makeSecondSubSectionExpand]="true"
  (filterChange)="onFilterChange($event)"
></stx-checkbox-tree-filter>
<stx-checkbox-group-filter
  [formGroupReference]="formGroupReference"
  filterName="treatmentStatus"
  [dictionaryOptions]="rejectedToSecondaryOptions"
  (filterChange)="onFilterChange($event)"
></stx-checkbox-group-filter>
}
